import { Component } from '@angular/core';

@Component({
    selector: 'app-raw-data-history',
    templateUrl: './raw-data-history.component.html',
    styleUrls: ['./raw-data-history.component.css'],
    standalone: false
})
export class RawDataHistoryComponent {
}
